import { Box } from "@mui/material";
import React from "react";

import { FactSource } from "../../types/productPlane";
import SourceMark from "./SourceMark";

export interface SourceMarksProps {
  // The documents behind one fact
  sources: FactSource[];
}

// A source the list does not hold comes last
const byNumber = (left: FactSource, right: FactSource): number =>
  (left.number ?? Infinity) - (right.number ?? Infinity);

/**
 * The marks of the sources behind one fact, by number.
 * Renders nothing for a fact without a source.
 */
const SourceMarks: React.FC<SourceMarksProps> = ({ sources }) => {
  if (sources.length === 0) {
    return null;
  }

  return (
    <Box component="span" sx={{ whiteSpace: "nowrap" }}>
      {[...sources].sort(byNumber).map((source) => (
        <SourceMark
          key={`${source.document_id}-${source.number}`}
          number={source.number}
          statement={source.statement}
          quote={source.quote}
          title={source.title}
          site={source.site}
          date={source.date}
        />
      ))}
    </Box>
  );
};

export default SourceMarks;
